import type { CacheLocation } from '@auth0/auth0-react';

/**
 * Utility functions for handling iframe-specific behavior
 */

/**
 * Detects if the current application is running inside an iframe
 * @returns true if running in iframe, false otherwise
 */
export const isRunningInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (_e) {
    // If we can't access window.top due to cross-origin restrictions,
    // we're likely in an iframe
    return true;
  }
};

/**
 * Gets the appropriate Auth0 configuration for iframe or standalone context
 * @returns Auth0 configuration object optimized for the current context
 */
export const getAuth0Config = () => {
  const isIframe = isRunningInIframe();

  return {
    // Use popup mode for iframes to avoid redirect issues
    usePopup: isIframe,
    // Use memory storage in iframes to avoid localStorage issues across domains
    cacheLocation: (isIframe ? 'memory' : 'localstorage') as CacheLocation,
    // Disable refresh tokens in iframes as they can cause issues
    useRefreshTokens: !isIframe,
    useRefreshTokensFallback: !isIframe,
  };
};
